// ============================================================================
// FNE-BRIDGE Frontend - Configuration i18n (Français, English, العربية)
// ============================================================================

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from '../locales/fr.json';
import en from '../locales/en.json';
import ar from '../locales/ar.json';

const STORAGE_KEY = 'fne-bridge-locale';

const savedLang = localStorage.getItem(STORAGE_KEY) || 'fr';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ar: { translation: ar },
    },
    lng: savedLang,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Persister le changement de langue
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
  // RTL pour l'arabe
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
});

// Initialiser la direction au chargement
document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = savedLang;

export default i18n;

// Langues disponibles (EN et AR désactivés temporairement — traductions incomplètes)
export const AVAILABLE_LANGUAGES = [
  { code: 'fr', label: 'Français', flag: 'FR', dir: 'ltr' },
  // { code: 'en', label: 'English', flag: 'EN', dir: 'ltr' },
  // { code: 'ar', label: 'العربية', flag: 'AR', dir: 'rtl' },
] as const;

export type LanguageCode = 'fr' | 'en' | 'ar';
